export default __webpack_public_path__ + "static/media/poc-health.a2373f78.jpg";